import React from "react";
import * as S from "./styles";
import {
  CONTACT_ADDRESS_SHORT,
  CONTACT_EMAIL,
  CONTACT_PHONE_NUMBER_DISPLAY,
  CONTACT_PHONE_NUMBER_RAW,
  HOMEPAGE_ANCHOR_CONTAINER_IDs,
} from "../../lib/constants";
import SocialLinks from "../ui/SocialLinks";
import { handleOpenSocialLink, isDonationSubdomain } from "../../lib/utils";

const quickLinks = [
  {
    href: "/",
    text: "Home",
    key: HOMEPAGE_ANCHOR_CONTAINER_IDs.hero.key,
  },
  {
    href: "/",
    text: "Features",
    key: HOMEPAGE_ANCHOR_CONTAINER_IDs.channels.key,
  },
  {
    href: "/agencies",
    text: "For Agencies",
  },
  {
    href: "/blogs",
    text: "Blog",
  },
];

const contactUsLink = {
  // href: "/",
  text: "Contact us",
  key: HOMEPAGE_ANCHOR_CONTAINER_IDs.contactUs.key,
};

const legalLinks = [
  { href: "/privacy", text: "Privacy Policy" },
  { href: "/terms-conditions", text: "Terms of Use" },
  { href: "/cookies", text: "Cookies" },
];

const DEFAULT_DESCRIPTION =
  "Persuasion, personalized. ReachThePeople.ai turns every contact into a conversation — multi-channel outreach driven by intelligence that gets better with every interaction. Built for political and advocacy campaigns.";

export function Footer({ description = DEFAULT_DESCRIPTION }) {
  const fullYear = new Date().getFullYear();

  const formatLinkHref = (link) => {
    if (link.key) {
      const baseHref = !link.href
        ? ""
        : link.href.endsWith("/")
          ? link.href
          : `${link.href}/`;
      return `${baseHref}#sc-${link.key}`;
    }

    return link.href || "#";
  };

  const mainWebsiteUrl = isDonationSubdomain()
    ? "https://reachthepeople.ai"
    : "";

  return (
    <S.StyledFooter>
      <S.FooterContainer>
        <S.TopDivider />
        <S.ContentWrapper>
          <S.LeftSection>
            <S.LogoAndDescription>
              <S.FooterLogoLink>
                <S.FooterLogo
                  src="/images/logos/reach-logo.svg"
                  alt="ReachThePeople.ai Logo"
                />
              </S.FooterLogoLink>
              <S.DescriptionText>{description}</S.DescriptionText>
            </S.LogoAndDescription>
            <S.ContactSection>
              <S.ContactPrompt>Any questions? Contact us:</S.ContactPrompt>
              <S.EmailLinkWrapper>
                <S.EmailLink href={`mailto:${CONTACT_EMAIL}`}>
                  {CONTACT_EMAIL}
                </S.EmailLink>
                <S.EmailIcon
                  src="/images/icons/arrow-top-right.svg"
                  alt="Arrow icon"
                />
              </S.EmailLinkWrapper>
              <S.EmailLinkWrapper>
                <S.EmailLink href={`tel:${CONTACT_PHONE_NUMBER_RAW}`}>
                  {CONTACT_PHONE_NUMBER_DISPLAY}
                </S.EmailLink>
                <S.EmailIcon
                  src="/images/icons/arrow-top-right.svg"
                  alt="Arrow icon"
                />
              </S.EmailLinkWrapper>
            </S.ContactSection>
          </S.LeftSection>

          <S.RightSection>
            <S.QuickLinksNav>
              {quickLinks.map((link) => (
                <S.FooterNavLink
                  href={formatLinkHref(link)}
                  key={link.text}
                  $isDisabled={!!mainWebsiteUrl}
                >
                  {link.text}
                </S.FooterNavLink>
              ))}
            </S.QuickLinksNav>
            <S.ContactAndSocials>
              <S.ContactInfo>
                <S.ContactUsLink
                  href={formatLinkHref(contactUsLink)}
                  $isDisabled={!!mainWebsiteUrl}
                >
                  {contactUsLink.text}
                </S.ContactUsLink>
                <S.Address>
                  {CONTACT_ADDRESS_SHORT.map((item, idx) => (
                    <div key={idx}>{`${item}${
                      idx !== CONTACT_ADDRESS_SHORT.length - 1 ? "," : ""
                    }`}</div>
                  ))}
                </S.Address>
              </S.ContactInfo>
              <SocialLinks
                location="footer"
                handleOpenLink={handleOpenSocialLink}
              />
            </S.ContactAndSocials>
          </S.RightSection>
        </S.ContentWrapper>

        <S.BottomSection>
          <S.BottomDivider />
          <S.BottomLinksWrapper>
            <S.CopyrightText>
              © {fullYear} ReachThePeople.ai. All rights reserved.
            </S.CopyrightText>
            <S.LegalLinks>
              {legalLinks.map((link) => (
                <S.LegalLink
                  key={link.href}
                  href={`${mainWebsiteUrl}${link.href}`}
                >
                  {link.text}
                </S.LegalLink>
              ))}
            </S.LegalLinks>
          </S.BottomLinksWrapper>
        </S.BottomSection>
      </S.FooterContainer>
    </S.StyledFooter>
  );
}
